import { Component, Input, Output, EventEmitter } from '@angular/core';
import { IButton } from '@common/interfaces/button.interface';
import { NavigationService } from '@services/navigation/navigation.service';

@Component({
  selector: 'app-button-group',
  templateUrl: './button-group.component.html',
  styleUrls: ['./button-group.component.scss'],
})
export class ButtonGroupComponent {
  @Input() buttons: IButton[];
  @Input() class: string;

  @Output() clickEvent: EventEmitter<boolean>;

  constructor(
    private navService: NavigationService,
  ) {
    this.clickEvent = new EventEmitter();
  }

  public click(route: string) {
    this.clickEvent.emit(true);
    this.navService.goTo(route);
  }

}
